import { Injectable } from "@angular/core";

@Injectable()
export class SideMenuService {
  sidenav: any;
  drawerContainer: any;
}
